import { define } from "../preactement/define";
import { Pagination } from "../../Pagination";
import { parseBooleanAttr, parseIntegerAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['class-name', 'compact', 'current-page', 'is-navigation-hidden', 'heading-aria-label', 'heading-level', 'href-template', 'start-label-text', 'start-aria-label', 'end-label-text', 'end-aria-label', 'root-id', 'total-pages'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    compact,
    currentPage,
    isNavigationHidden,
    headingAriaLabel,
    hrefTemplate,
    rootId,
    totalPages,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Pagination, {
    ...otherProps,
    ariaLabel: headingAriaLabel,
    compact: parseBooleanAttr(compact),
    currentPage: parseIntegerAttr(currentPage) ?? 0,
    isNavigationHidden: parseBooleanAttr(isNavigationHidden),
    renderHref: page => (hrefTemplate ?? '#page={page}').replace('{page}', '' + page),
    id: rootId,
    totalPages: parseIntegerAttr(totalPages) ?? 0
  });
};
define('ds-pagination', () => Wrapper, {
  attributes,
  events: [['onPageChange', (event, page) => ({
    ...event,
    detail: {
      target: event.target,
      page
    },
    preventDefault: () => event.preventDefault()
  })]]
});